$(function(){$(".hover").on("click",".js-btnMoreInfoProduct",function(o){o.preventDefault(),moreInfoAboutProduct($(this),$(this).data("id"))})});